'use strict';

/**
 * Payments
 */
class Payments {
  /**
   * Constructor of Payments.
   * @param {Object} options
   * @param {Object} player
   * @return {*}
   */
  constructor(options, player) {
    this._options = options;
    this._player = player;
  }

  async purchase() {
    throw new Error('Not supported yet');
  }

  async getPurchases() {
    throw new Error('Not supported yet');
  }

  async getCatalog() {
    throw new Error('Not supported yet');
  }
}
export default Payments;
